import axios from "axios";
const axiosInstance = axios.create({
  // axios start
  // baseURL: "http://172.16.5.13:4022/v1/",
  // axios.defaults.baseURL = "http://172.16.5.18:8000/";
  // baseURL: "https://bkapistaging.treeone.one/v1/",
  baseURL: "https://bkticketapi.treeone.one/v1/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = JSON.parse(localStorage.getItem("cognitoToken"));
    if (config.headers) {
      config.headers.Authorization = accessToken;
    }
    return config;
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.msg === "invalid Token") {
      window.location.href = "/auth";
      return;
    } else {
      return response;
    }
    // console.log(`interceptors.response`, response);
  },
  (error) => {
    console.log(`interceptors.response`, error);
  }
);

// Delegate urls
// global.DelegateUrl = "http://172.16.5.9:2255/#/";
// global.DelegateUrl = "https://webdelegate.treeone.one/#/";
global.DelegateUrl = "https://admin.delegatetask.app/#/";

// cognito urls
// global.congito = "https://staging.tabtreesoftwares.com";
global.congito = "https://accounts.tabtreesoftwares.com/";

// local domains
// global.domain = "http://172.16.5.13:3001";
global.domain = "https://web.treeoneticketing.com";

// logout url for cognito  staging / live

// global.logout =
//   "https://ped6ffzgfvdqxa66oe65hssbbi0jfudt.lambda-url.ap-south-1.on.aws/";

global.logout =
  "https://kjyq5zg6solvmx4sknm5ix6hay0vmeaz.lambda-url.ap-south-1.on.aws/";

global.$axios = axiosInstance;
global.$test = "axios";
export default axiosInstance;
// axios end
